import { ComboField } from '@components/Fields/ComboField';
import { FilterBar } from '@components/FilterBar';
import { GridItem } from '@components/GridItem';
import { IFilter } from '@hooks/useFilter';
import { MenuItem } from '@material-ui/core';
import { EnumContratoClienteStatus, IComboContratoClienteStatus } from '@model/ContratoClienteStatus';
import { EnumFaturaStatus } from '@model/FaturaStatus';
import { IContratoClienteFilter } from '@services/ClienteService';
import React from 'react';

export type ContratoFilterProps = {
    filter: IFilter<IContratoClienteFilter>
    contratoClienteStatusCombo: IComboContratoClienteStatus
    isLoading: boolean
}

export function ContratoFilter ({ filter, contratoClienteStatusCombo, isLoading }: ContratoFilterProps) {
    const { fields } = filter;

    return (
        <FilterBar>
            <GridItem floatRight>
                <ComboField
                    field={fields.contratoClienteStatus}
                    disabled={isLoading}
                    updateFieldStateOnChange
                    onValueChanged={(value: EnumContratoClienteStatus) => {
                        if (value !== fields.contratoClienteStatus.value) {
                            filter.handleFilterRequest();
                        }
                    }}
                >
                    <MenuItem key={0} value={EnumFaturaStatus.None}>Status: Todos</MenuItem>
                    {
                        contratoClienteStatusCombo.createOptions({
                            prefix: "Status: "
                        })
                    }
                </ComboField>
            </GridItem>
        </FilterBar>
    )
}